import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";
import { PostJobPropsType } from "../interface/job_board";
import { ChangePasswordField } from "../interface/users";

export const apiGetUsers = async (token: string) => {
  const token_key = token ?? "";

  try {
    const uri = `/admin/users`;
    const cfg = await getRequestConfiguration({
      Authorization: `Bearer ${token_key}`,
    });

    return await Axios.get(uri, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetUser = async (fieldValues: { userId: string }) => {
  try {
    const uri = `/admin/users/user/${fieldValues.userId}`;

    return await Axios.get(uri);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiVerifyUserPassword = async (
  fieldValues: PostJobPropsType,
  token: string,
) => {
  const formData = new URLSearchParams();
  const token_key = token ?? "";

  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/users/user/password`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token_key}`,
    });

    return await Axios.put(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiChangePassword = async (
  fieldValues: ChangePasswordField,
  token: string,
) => {
  const formData = new URLSearchParams();
  const token_key = token ?? "";

  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/admin/users/user/password`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token_key}`,
    });

    return await Axios.patch(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export interface CreateAdminProps {
  first_name: string;
  last_name: string;
  phone_number: string;
  password: string;
  email: string;
  middle_name: string;
  gender: string;
}
export const apiCreateAdmin = async (
  fieldValues: CreateAdminProps,
  token: string,
) => {
  const formData = new URLSearchParams();
  const token_key = token ?? "";

  // Append all form fields to FormData
  Object.entries(fieldValues).forEach(([key, value]) => {
    if (value !== undefined) {
      formData.append(key, value.toString());
    }
  });
  try {
    const uri = `/admin/users/`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${token_key}`,
    });

    return await Axios.post(uri, formData, cfg);
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message,
    };
  }
};

export const apiGetSettings = async () => {
  try {
    const uri = `/admin/settings/setting`;
    const response = await Axios.get(uri);
    return response.data;
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg:
        e?.response?.data?.message || e?.message || "Failed to fetch settings",
    };
  }
};

export const apiUpdateTokenCost = async (rate: string) => {
  try {
    const uri = `/admin/settings/token/rate`;
    const formData = new URLSearchParams();
    formData.append("rate", rate);

    const response = await Axios.post(uri, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg:
        e?.response?.data?.message ||
        e?.message ||
        "Failed to update token rate",
    };
  }
};

export const apiUpdateConversionRate = async (rates: {
  job: string;
  shortlisting: string;
  medic: string;
  mobility: string;
  performance: string;
  reports: string;
}) => {
  try {
    const uri = `/admin/settings/conversion/rate`;
    const formData = new URLSearchParams();
    Object.entries(rates).forEach(([key, value]) =>
      formData.append(key, value.toString()),
    );

    const response = await Axios.post(uri, formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    return response.data;
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg:
        e?.response?.data?.message ||
        e?.message ||
        "Failed to update conversion rates",
    };
  }
};

export const apiSuspendUser = async (params: {
  userId: string;
  suspended: boolean;
}) => {
  try {
    const uri = `/admin/users/user/${params.userId}/suspend`;
    const response = await Axios.put(uri, {
      suspended: params.suspended,
    });
    return response.data;
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg:
        e?.response?.data?.message ||
        e?.message ||
        "Failed to update user status",
    };
  }
};

/**
 * Delete a user account
 */
export const apiDeleteUser = async (userId: string) => {
  try {
    const uri = `/admin/users/user/${userId}/delete`;
    const response = await Axios.delete(uri);
    return response.data;
  } catch (e: any) {
    console.error(e);
    return {
      data: {},
      status: "error",
      msg: e?.response?.data?.message || e?.message || "Failed to delete user",
    };
  }
};
